import { Tax } from './tax';
import { ProductDetails } from '../FacilityManager/product-details';
import { Cess } from './cess';
import { ProductSubGroup } from '../OrderManagement/OrderStock/RewMaterials/ProductSubGroup/product-sub-group';

import { Location } from '../Master/Location/location';
import { BankPayment } from '../Collection/bank-payment';
import { CardPayment } from '../Collection/card-payment';
import { CashPayment } from '../Collection/cash-payment';
import { PaytmPayment } from '../Collection/paytm-payment';
import { UpiPayment } from '../Collection/upi-payment';
import { OrganiserDetail } from '../Master/OrganiserDetail/organiser-detail';
import { ServiceMan } from '../Master/ServiceMan/service-man';
import { CouponPayment } from '../Collection/coupon-payment';
import { WalletPayment } from '../Collection/wallet-payment';
import { SwipePayment } from '../Collection/swipe-payment';
import { GatewayPayment } from '../Collection/gateway-payment';

export class Cart {

    price: number;
    productCode: number;
    productName: string;
    systemStock: number;
    qty: number;
    total: number;
    discPercent: number;
    discAmt: number = 0;
    offerDiscRate: number;
    offerDiscAmt: number;
    totalDiscRate: number;
    totalDiscAmt: number;
    baseAmt: number;
    tax: Tax;
    cgstRate: number;
    cgstAmt: number;
    sgstRate: number;
    sgstAmt: number;
    igstRate: number;
    igstAmt: number;
    ugstRate: number;
    ugstAmt: number;
    cessRate: number;
    cessAmt: number;
    netAmt: number;
    details: ProductDetails[];

    //For Pos Organiser

    orgDtlsId: number;
    billTime: string;
    cartStatus: string;
    fromLocationCode: number;
    subTotal: number;
    discount: number;
    totalPaid: number;
    balance: number;
    servedbyCode: number;
    customerCode: string;
    noOfTimesPrinted: number;
    noOfTimesParked: number;
    refNo: string
    cancelDate: string;
    byUserCode: string;
    printTokenCode: number;
    reservationCode: number;
    checkedOutTime: string;
    timeStamp: string;
    customer: any;
    serviceMan: ServiceMan;
    cartOffers = [];

    //added for convert cart to productdetails
    //api change changes
    salePrice: number;
    productSubGroupName: string;
    subGroupCode: number;
    netSalePrice: number;
    qtyInHand: number;
    cessRateCode: number;

    product_Code: number;
    product_Name: string;
    product_Unit: string;
    sale_Price: number;
    net_Sale_Price: number;
    cess: Cess;
    sl: number;
    productSubGroup: ProductSubGroup
    amount: number = 0;
    rate: number
    productGroupName: string
    productdetail: ProductDetails;
    sale_price: number;
    orderNo: number
    productDetail: ProductDetails
    orderQty: number
    orderAmount: number
    dispatchQty: number
    dispatchAmount: number
    receivedQty: number
    receiveAmount: number
    cartNo: string;

    //manage bill

    organiserdetail: OrganiserDetail;
    location: Location;

    isPrinted: boolean = false;
    cartDetails: any;

    // cash register check out
    bankAccountCode: number;

    dispatchedQty: number = 0;
    offerAvailable: boolean = false;
    offerProduct: boolean = false;

    //sale invoice
    discountRate: number;
    taxableValue: number;

    // for payment
    cashpayment?: CashPayment;
    upipayment?: UpiPayment;
    cardpayment?: CardPayment;
    paytmPayment: PaytmPayment;
    couponpayment?: CouponPayment;
    bankpayment?: BankPayment;
    walletPayment?: WalletPayment;
    swipePayment?: SwipePayment;
    gatewayPayment?: GatewayPayment;

    orderedQty: number
    itemCode: string;
    freeByProductCode: number;
    offerId: string;

    max_Discount_Percentage: number;
    refundAmt?: number = 0;
    tenderAmt?: number;

    serialNo: number;
    deliveryAddressRefNo: string;

    taxRate: number;
    productUnit: string;

    maxDiscountPercentage: number;
    productType: string;
    hsnCode: number;

    designForProductCode: number;
    
    //Added For My Coupon 
    discountCode: string;
    freeByDiscountCode: string;
}
